module.exports = __webpack_public_path__ + "img/teams-header.3a106dbf.jpg";